import {
  TableSortLabel as NovaBaseTableSortLabel,
  TableSortLabelProps as NovaTableSortLabelProps,
} from '@fme-nova/components'
import {
  default as MuiTableSortLabelBase,
  TableSortLabelProps as MuiTableSortLabelProps,
} from '@mui/material/TableSortLabel'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'

const MuiTableSortLabel = styled(MuiTableSortLabelBase)`
  color: ${COLORS.text.primary};

  &:hover {
    color: ${COLORS.text.primary};
  }

  white-space: nowrap;
`

const NovaTableSortLabel = styled(NovaBaseTableSortLabel)`
  color: ${COLORS.text.primary};

  &:hover {
    color: ${COLORS.text.primary};
  }

  white-space: nowrap;
`

export const TableSortLabel = createComponentWrapperWithRef<MuiTableSortLabelProps | NovaTableSortLabelProps>(
  {
    mui: MuiTableSortLabel,
    nova: NovaTableSortLabel,
  },
  'TableSortLabel',
)
